module.exports = __webpack_public_path__ + "img/foot_original.9695686a.jpg";